import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_WorkerListTable = _resolveComponent("WorkerListTable");
    const _component_LoadingMask = _resolveComponent("LoadingMask");
    const _component_VerticalDividedDialog = _resolveComponent("VerticalDividedDialog");
    return (_openBlock(), _createBlock(_component_VerticalDividedDialog, {
        "is-open": _ctx.isWorkerSettingDialogOpen,
        "on-cancel": _ctx.handleClickCancelDialogBtn,
        "is-divided": false,
        "has-footer": false,
        "dialog-css-class": "width-xs ratio-full"
    }, {
        title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}title`)), 1 /* TEXT */)
        ]),
        appendTitle: _withCtx(() => [
            _createTextVNode(" / " + _toDisplayString(_ctx.getterSelectedSettingGroupName), 1 /* TEXT */)
        ]),
        leftSubTitle: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}left_sub_title`)), 1 /* TEXT */)
        ]),
        appendLeftSubTitle: _withCtx(() => [
            _createTextVNode(_toDisplayString(`(${_ctx.getterFeeGroupWorkerListLength})`), 1 /* TEXT */)
        ]),
        leftContent: _withCtx(() => [
            _createVNode(_component_WorkerListTable, {
                "is-fetching": _ctx.isFetching,
                "is-error": _ctx.isError
            }, null, 8 /* PROPS */, ["is-fetching", "is-error"]),
            _createVNode(_component_LoadingMask, {
                "is-fetching": _ctx.isFetching,
                opacity: 0,
                color: "primary",
                size: "32"
            }, null, 8 /* PROPS */, ["is-fetching"])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-open", "on-cancel"]));
}
